import 'core-js'
import 'whatwg-fetch'
import './scss/main.scss'
import './apps'
import $ from 'jquery'
import 'jquery-ui/ui/core'
import 'jquery-ui/ui/widgets/draggable'
import 'popper.js'
import 'bootstrap'
import 'slick-carousel'

document.querySelectorAll('.data-point').forEach((point) => {
    const top = point.getAttribute('data-top') || 0
    const left = point.getAttribute('data-left') || 0
    point.style.top = `${top}%`
    point.style.left = `${left}%`
})

$(".project-map.backend .data-point").draggable({
    containment: "parent",
    stop: ({target}, ui) => {
        const point = target
        let positionLeft = (point.offsetLeft / point.parentElement.clientWidth) * 100
        let positionTop = (point.offsetTop / point.parentElement.clientHeight) * 100
        positionLeft = Math.round(positionLeft * 10) / 10
        positionTop = Math.round(positionTop * 10) / 10
        $('.project-map.backend #left').text(positionLeft)
        $('.project-map.backend #top').text(positionTop)
    }
})

$(".slick").slick({
    // normal options...
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 2,
    adaptiveHeight: true,
    prevArrow: '<button class="slick-prev slick-arrow" ><i class="icon icon--arrow-left"></i></button>',
    nextArrow: '<button class="slick-next slick-arrow" ><i class="icon icon--arrow-right"></i></button>',
    responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
    ]
  });

// scroll nav
let fixNavigation = () => {
    const page = document.getElementById('page')
    const navElement = document.querySelector('.navigation')
    const className = 'nav--fixed'

    if (window.scrollY > 0 && !navElement.classList.contains(className)) {
        navElement.classList.add(className)
    }
    if (window.scrollY === 0 && navElement.classList.contains(className)) {
        navElement.classList.remove(className)
    }
}

window.addEventListener('scroll', fixNavigation)
window.addEventListener('resize', fixNavigation)


// mobile-menu && login-box
let toggleNavClass = (event, className, toggleActiveElement, baseElement) => {
    event.preventDefault()

    if (baseElement.classList.contains(className)) {
        toggleActiveElement.classList.remove('active')
        baseElement.classList.remove(className)
    } else {
        toggleActiveElement.classList.add('active')
        baseElement.classList.add(className)
    }
}

let loginLink = document.getElementById('login')
let menuLink = document.getElementById('menu')
let loginDesktopLink = document.getElementById('login-desktop')
let navMobile = document.querySelector('.menu-mobile')
let navDesktop = document.querySelector('.menu-desktop')

loginLink.addEventListener('click', (e) => toggleNavClass(e, 'nav--login', loginLink, navMobile))
menuLink.addEventListener('click', (e) => toggleNavClass(e, 'nav--menu', menuLink, navMobile))
loginDesktopLink.addEventListener('click', (e) => toggleNavClass(e, 'nav--login', loginDesktopLink, navDesktop))

// section
const sections = document.querySelectorAll('.section--inset');
let prepareSections = () => {
    for (let i=0; i < sections.length; i++) {
        let section = sections[i];
        let margin = section.getAttribute('data-margin')
        if (margin) {
            section.style.height = section.scrollHeight - margin + 'px';
            section.style.marginBottom = margin + 'px';
        }
    }
}

prepareSections()
window.addEventListener('resize', prepareSections)
